import { Form } from "antd";
import { HeaderOverview, IRenderBarChart, RenderBarChart } from "components";
import dayjs from "config/dayjs";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkData,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardSLATotal } from "service/dashboard/central/homecare";
import { IData } from "service/dashboard/interface";

const SLA_Graph = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const dailySlaDate = Form.useWatch("dailySlaDate");
  const date = findDate(dailySlaDate);

  const { data, isFetching, isError, error } = useGetDashboardSLATotal({
    ...date,
    property,
  });

  const findData = checkData(data);

  const getData: IData[] =
    findData?.map((e) => {
      const date = dayjs(e.date).date();
      return {
        name: `${date}`,
        count: e?.thresholdStandard || 0,
        isLowerThreshold: e.isLowerThreshold,
        all: e?.all || 0
      };
    }) || [];

  const findNoCount = getData.some((e) => e.count > 0);

  const dataBar: IRenderBarChart = {
    data: getData,
    dataKeyX: "name",
    dataKeyY: "count",
    color: "#BBD649",
    isSla: true,
    height:500
  };

  return (
    <WrapperBG>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("engineering_service_sla")}
          name="dailySlaDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="300px" />
        ) : !findData || findData.length <= 0 || !findNoCount ? (
          <NoDataDashboard height="300px" />
        ) : (
          <RenderBarChart {...dataBar} />
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default SLA_Graph;
